import { Box } from '@deckee/deck-hand';
import React, { FC, ReactNode } from 'react';

export interface CaptionedIconLockupProps {
  icon: ReactNode;
  caption: string;
  className?: string;
}

const CaptionedIconLockup: FC<CaptionedIconLockupProps> = ({
  icon,
  caption,
  className,
}) => (
  <Box
    className={className}
    display="flex"
    alignItems="center"
    flexDirection="column"
    justifyContent="space-between"
  >
    <Box mb={2}>{icon}</Box>
    <Box fontSize="2" fontWeight="bold">
      {caption}
    </Box>
  </Box>
);

CaptionedIconLockup.defaultProps = {
  className: undefined,
};

export default CaptionedIconLockup;
